/* eslint-disable max-lines */
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc'; // dependent on utc plugin
import { DEFECT_DISTRIBUTION_CONSTANTS } from 'store/aiPerformance/constants';
import {
  fileSetLocalDefectsStatus,
  IRR_FROM_SESSION_STORAGE,
} from 'store/reviewData/constants';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

export const timeZone = dayjs.tz.guess();
const today = dayjs().tz(timeZone);
export const start = today.subtract(6, 'day').startOf('day').toDate();
export const end = today.endOf('day').toDate();

const initialState = {
  upload: {
    sessions: [],
    metaCount: 0,
    uploadInProgress: false,
  },
  reviewButtons: {
    data: {
      aiAssistance: ['Add AI Model'],
      'scratch-annotation': {
        'single-fileset': [
          'Add',
          'Replace',
          'Remove',
          // 'Mark AI label Correct',
          'Replace Class',
          'Delete Box',
          'Remove Class',
          // 'Mark all Boxes Correct',
          'Add Comment',
          'Add Tag(s)',
        ],
        'multiple-fileSets': [
          'Add',
          'Replace',
          'Remove',
          // 'Mark AI label Correct',
          'Replace Class',
          'Delete Box',
          'Remove Class',
          // 'Mark all Boxes Correct',
          'Add Comment',
          'Add Tag(s)',
        ],
        'single-box-ai': [
          // 'Mark AI label Correct',
          'Replace Class',
          'Delete Box',
          'Remove Class',
          // 'Mark all Boxes Correct',
          'Add Comment',
          'Add Tag(s)',
        ],
        'single-box-user': [
          'Replace Class',
          'Delete Box',
          'Remove Class',
          'Add Comment',
          'Add Tag(s)',
        ],
        'multiple-boxes': [
          // 'Mark AI label Correct',
          'Replace Class',
          'Delete Box',
          'Remove Class',
          // 'Mark all Boxes Correct',
          'Add Comment',
        ],
      },
      'ai-annotation': {
        'single-fileset': [
          'Add',
          'Replace',
          'Remove',
          'Mark AI label Correct',
          'Replace Class',
          'Delete Box',
          'Remove Class',
          'Mark all Boxes Correct',
          'Add Comment',
          'Add Tag(s)',
        ],
        'multiple-fileSets': [
          'Add',
          'Replace',
          'Remove',
          'Mark AI label Correct',
          'Replace Class',
          'Delete Box',
          'Remove Class',
          'Mark all Boxes Correct',
          'Add Comment',
          'Add Tag(s)',
        ],
        'single-box-ai': [
          'Mark AI label Correct',
          'Replace Class',
          'Delete Box',
          'Remove Class',
          'Mark all Boxes Correct',
          'Add Comment',
          'Add Tag(s)',
        ],
        'single-box-user': [
          'Replace Class',
          'Delete Box',
          'Remove Class',
          'Add Comment',
          'Add Tag(s)',
        ],
        'multiple-boxes': [
          'Mark AI label Correct',
          'Replace Class',
          'Delete Box',
          'Remove Class',
          'Mark all Boxes Correct',
          'Add Comment',
        ],
      },
      'ground-truth-correction': {
        'single-fileset': [
          'Add',
          'Replace',
          'Remove',
          'Replace Class',
          'Delete Box',
          'Remove Class',
          'Add Comment',
          'Add Tag(s)',
        ],
        'multiple-fileSets': [
          'Add',
          'Replace',
          'Remove',
          'Replace Class',
          'Delete Box',
          'Remove Class',
          'Add Comment',
          'Add Tag(s)',
        ],
        'single-box-other': ['Add Comment', 'Add Tag(s)'],
        'single-box-gt': [
          'Add',
          'Replace',
          'Remove',
          'Replace Class',
          'Delete Box',
          'Remove Class',
          'Add Comment',
          'Add Tag(s)',
        ],
        'multiple-boxes': ['Replace Class', 'Add Comment'],
      },
      'general-viewing': {
        'single-fileset': ['Add Comment', 'Add Tag(s)'],
        'multiple-fileSets': ['Add Comment', 'Add Tag(s)'],
        'single-box-self': ['Add Comment', 'Add Tag(s)'],
        'single-box-other': ['Add Comment', 'Add Tag(s)'],
        'multiple-boxes': ['Add Comment'],
      },
      'reviewer-annotation': {
        'single-fileset': [
          'Add',
          'Replace',
          'Remove',
          'Mark AI label Correct',
          'Replace Class',
          'Delete Box',
          'Remove Class',
          'Mark all Boxes Correct',
          'Add Comment',
          'Add Tag(s)',
        ],
        'multiple-fileSets': [
          'Add',
          'Remove',
          'Mark AI label Correct',
          'Replace Class',
          'Delete Box',
          'Remove Class',
          'Mark all Boxes Correct',
          'Add Comment',
          'Add Tag(s)',
        ],
        'single-box-ai': [
          'Mark AI label Correct',
          'Replace Class',
          'Delete Box',
          'Remove Class',
          'Mark all Boxes Correct',
          'Add Comment',
          'Add Tag(s)',
        ],
        'single-box-user': [
          'Replace Class',
          'Delete Box',
          'Remove Class',
          'Add Comment',
          'Add Tag(s)',
        ],
        'multiple-boxes': [
          'Mark AI label Correct',
          'Replace Class',
          'Delete Box',
          'Remove Class',
          'Mark all Boxes Correct',
          'Add Comment',
        ],
      },
      review: {
        'single-fileset': [
          'Add',
          'Replace',
          'Remove',
          'Replace Class',
          'Delete Box',
          'Add Comment',
          'Add Tag(s)',
        ],
        'multiple-fileSets': [
          'Add',
          'Replace',
          'Remove',
          // 'Labelling Guide',
          'Mark AI label Correct',
          'Mark as Label',
          'Replace Class',
          'Delete Box',
          'Add Comment',
          'Add Tag(s)',
        ],
        'single-box-ai': [
          'Add',
          'Replace',
          'Remove',
          'Replace Class',
          'Delete Box',
          'Add Comment',
          'Add Tag(s)',
        ],
        'single-box-user': [
          'Add',
          'Replace',
          'Remove',
          'Replace Class',
          'Delete Box',
          'Add Comment',
          'Add Tag(s)',
        ],
        'multiple-boxes': [
          'Add',
          'Replace',
          'Remove',
          'Replace Class',
          'Delete Box',
          'Add Comment',
          'Add Tag(s)',
        ],
      },
      audit: {
        'single-fileset': [
          'Add',
          'Replace',
          'Remove',
          'Replace Class',
          'Delete Box',
          'Add Comment',
          'Add Tag(s)',
        ],
        'multiple-fileSets': [
          'Add',
          'Replace',
          'Remove',
          'Replace Class',
          'Delete Box',
          'Add Comment',
          'Add Tag(s)',
        ],
        'single-box-ai': [
          'Add',
          'Replace',
          'Remove',
          'Replace Class',
          'Delete Box',
          'Add Comment',
          'Add Tag(s)',
        ],
        'single-box-user': [
          'Add',
          'Replace',
          'Remove',
          'Replace Class',
          'Delete Box',
          'Add Comment',
          'Add Tag(s)',
        ],
        'multiple-boxes': [
          'Add',
          'Replace',
          'Remove',
          'Replace Class',
          'Delete Box',
          'Add Comment',
          'Add Tag(s)',
        ],
      },
      'manual-classify': {
        'single-fileset': [
          'Add',
          'Replace',
          'Remove',
          'Replace Class',
          'Delete Box',
          'Add Comment',
          'Add Tag(s)',
        ],
        'multiple-fileSets': [
          'Add',
          'Replace',
          'Remove',
          'Mark AI label Correct',
          'Mark as Label',
          'Replace Class',
          'Delete Box',
          'Add Comment',
          'Add Tag(s)',
        ],
        'single-box-ai': [
          'Add',
          'Replace',
          'Remove',
          'Replace Class',
          'Delete Box',
          'Add Comment',
          'Add Tag(s)',
        ],
        'single-box-user': [
          'Add',
          'Replace',
          'Remove',
          'Replace Class',
          'Delete Box',
          'Add Comment',
          'Add Tag(s)',
        ],
        'multiple-boxes': [
          'Add',
          'Replace',
          'Remove',
          'Replace Class',
          'Delete Box',
          'Add Comment',
          'Add Tag(s)',
        ],
      },
      clustering: {
        'single-fileset': [
          'Add',
          'Replace',
          'Remove',
          'Replace Class',
          'Delete Box',
          'Add Comment',
          'Add Tag(s)',
        ],
        'multiple-fileSets': [
          'Add',
          'Replace',
          'Remove',
          // 'Labelling Guide',
          'Mark AI label Correct',
          'Mark as Label',
          'Replace Class',
          'Delete Box',
          'Add Comment',
          'Add Tag(s)',
        ],
        'single-box-ai': [
          'Add',
          'Replace',
          'Remove',
          'Replace Class',
          'Delete Box',
          'Add Comment',
          'Add Tag(s)',
        ],
        'single-box-user': [
          'Add',
          'Replace',
          'Remove',
          'Replace Class',
          'Delete Box',
          'Add Comment',
          'Add Tag(s)',
        ],
        'multiple-boxes': [
          'Add',
          'Replace',
          'Remove',
          'Replace Class',
          'Delete Box',
          'Add Comment',
          'Add Tag(s)',
        ],
      },
    },
    availableButtons: ['View all Similar Images'],
    isAIAnnotation: false,
  },
  review: {
    data: [],
    fetchingReviewData: false,
    isBackGroundUpdate: false,
    fileSetCount: 0,
    uploadSessionId: '',
    next: null,
    gridModes: [{ label: 'Canvas View' }, { label: 'Grid View' }],
    activeGridMode: 'Canvas View',
    imageModes: [],
    activeImageMode: '',
    activeImg: [0],
    fileSetDefects: {},
    isFileSetDefectsLoading: false,
    userClassification: { count: 0, data: {} },
    selectedTool: 'select',
    imageSizes: {},
    annotatorInput: [
      {
        id: '',
        src: '',
        name: '',
        regions: [],
      },
    ],
    useAIAssistance: true,
    // Incase of forced refresh that are triggered by us to update data,
    // we were losing the current selected AI Assistance model,
    // which was causing inconsistencies in UX and also was leading to
    // showing different data to the user after the refresh.
    // So, we are storing the current applied model in the session storage,
    // before triggering forced refresh, to persist the model after the refresh,
    // and provide consistent UX.
    appliedForAllModelId: null,
    modelVisibilityObj: {},
    modelDetectionList: [],
    userDetectionList: [],
    modelsDict: {},
    aiDefects: [],
    taskId: null,
    otherDefects: [],
    selectAll: false,
    containerMeta: null,
    isBulkClassificationUpdating: false,
    isUserClassificationLoading: false,
    searchText: '',
    isFileSetDeleting: false,
    selectedWaferDots: null,
    selectedClusterRectangle: null,
    transferableImageIndexes: new Set(),
    fileSetLocalDefects: {},
    fileSetLocalDefectsSavingStatus: fileSetLocalDefectsStatus.NONE,
    markImageCenter: false,
    defectColorCodes: {},
    irr: {
      showIRRview:
        typeof sessionStorage !== 'undefined'
          ? !!sessionStorage.getItem(IRR_FROM_SESSION_STORAGE)
          : false,
      data:
        typeof sessionStorage !== 'undefined'
          ? JSON.parse(sessionStorage.getItem(IRR_FROM_SESSION_STORAGE))
          : null,
      isLoading: false,
    },
    isLive: false,
    disableHotKeys: false,
    fileSetTags: [],
    fileSetTagUpdates: {},
  },
  segregateImages: {
    segregationType: 'wafer',
    splitRatio: 70,
    trainTag: '',
    testTag: '',
    isExistingTagModal: false,
    isConfirmationModalOpen: false,
  },
  filters: {
    filters: {},
    folderDict: {},
    filtersLoaded: false,
    params: {},
    paramsString: '',
    packId: '',
    date: { start, end },
  },
  common: {
    userInfo: {},
    models: [],
    modelsDict: {},
    defects: [],
    defectsDict: {},
    useCase: [],
    useCaseLoaded: false,
    useCaseLoading: false,
    userInfoLoaded: false,
    defectsLoaded: false,
    modelsLoaded: false,
    modelsLoading: false,
    defectsLoading: false,
    userInfoLoading: false,
    subscriptionLoaded: false,
    featureFlags: {
      isUrOrEnabled: false,
      isInspectionReportEnabled: false,
      isWafermapTxtExportEnabled: false,
      isIrrEnabled: false,
      isNewManualReclassEnabled: false,
      isSimilarImagesEnabled: true,
      isUniqueImagesEnabled: true,
      isClusteringEnabled: true,
      isTrainingFreeClusteringEnabled: false,
      isTiffToPngEnabled: true,
      isMandarinSupportEnabled: true,
      isLotBookEnabled: true,
      shouldDisableUserActivityTracking: false,
      isDefectCountBoxChartEnabled: false,
      isUseCaseResolverWildcardEnabled: false,
    },
    featureFlagsLoading: false,
    loadedSubscriptionId: null,
    isUrOrEnabled: false,
  },
  pagination: {
    defaultPageSize: 30,
  },
  defectLibrary: {
    drawerOpen: false,
    activeStep: 0,
    selected: [],
    allSelected: false,
    bookmarked: [],
    allBookmarked: false,
    mode: '',
    defect: {},
    total: 0,
    globalMode: '',
    expandAll: false,
    data: [],
    rowsPerPage: 30,
    page: 1,
  },
  modelLibrary: {
    drawerOpen: false,
    activeStep: 0,
    selected: [],
    allSelected: false,
    bookmarked: [],
    allBookmarked: false,
    trainModelId: null,
    model: {},
    uploadModelDrawer: false,

    showProgress: false,
    total: 0,
    uploaded: 0,
    showTrainProgress: false,
  },
  allUploads: {
    drawerOpen: false,
    activeStep: 0,
    inferenceSelected: [],
    data: [],
    downloadBtn: false,
    downloading: false,
    page: 1,
    rowsPerPage: 30,
    total: 0,
    infoModes: [
      { label: 'Folder', sublabel: '' },
      { label: 'Datasets', sublabel: '' },
    ],
    infoMode: 'Folder',
  },
  usecase: {
    drawerOpen: false,
    activeStep: 0,
    selected: [],
    data: [],
    page: 1,
    rowsPerPage: 30,
    usecase: {},
    mode: '',
    globalMode: '',
    modelDefectDrawer: false,
  },
  aiPerformance: {
    drawerOpen: false,
    drawerStatus: '',
    mode: '',
    unit: '',
    confusionUsecase: {},
    confusionModel: {},
    drawerUsecase: null,
    activeUsecaseCount: null,
    misclassificationImagesRowIds: {},
    defectDistribution: {
      [DEFECT_DISTRIBUTION_CONSTANTS.USECASE_DEFECTS]: {
        isLoading: false,
        data: {},
        isError: false,
      },
      [DEFECT_DISTRIBUTION_CONSTANTS.CONFUSION_MATRICS]: {
        isLoading: false,
        data: {},
        isError: false,
      },
      [DEFECT_DISTRIBUTION_CONSTANTS.MISCLASSIFICATION_PAIR]: {
        isLoading: false,
        data: [],
        isError: false,
      },
      [DEFECT_DISTRIBUTION_CONSTANTS.DEFECT_BASED_DISTRIBUTION]: {
        isLoading: false,
        data: [],
        isError: false,
      },
      [DEFECT_DISTRIBUTION_CONSTANTS.FOLDER_BASED_DISTRIBUTION]: {
        isLoading: false,
        data: [],
        isError: false,
      },
      [DEFECT_DISTRIBUTION_CONSTANTS.WAFER_BASED_DISTRIBUTION]: {
        isLoading: false,
        data: [],
        isError: false,
      },
    },
  },
  notifications: {
    data: [],
    total: 0,
    read: 0,
    unread: 0,
    next: null,
  },
  configuration: {
    usecases: [],
  },
  helpers: {
    usecases: {},
    wafers: {},
    models: {},
    modelLoading: false,
    usecasesLoading: false,
    wafersLoading: false,
    waferTableStructure: [],
    imageFit: 'fit_to_screen',
    lotTableStructure: [],
    usecaseRoutingTableStructure: [],
    lastSelectedDefect: null,
  },
  modelTraining: {
    activeStep: 0,
    modelName: '',
    newModel: {},
    isEdit: false,
    isDialogOpen: false,
    dialogVariant: null,
    activeImg: [],
    selectAll: false,
    fileSetData: [],
    fetchingFileSets: false,
    next: null,
    count: 0,
    defectsInstancesCountAdded: 0,
    defectsInstancesCountNotAdded: 0,
    addedToTraining: null,
    usecase: {},
    oldModel: {},
    selectedDefects: [],
    isSameModelNameError: false,
    fileSetDefects: {},
    isFileSetDefectsLoading: false,
    activeTrainingMode: 'Not Added for Training',
    pendingTaskId: '',
    shouldTrainingOpen: false,
    trainingDataInformation: {},
    trainingConfiguration: {},
    containerMeta: null,
  },
  taskQueue: {
    tasks: [],
    pendingStatusIds: [],
    activeMode: 'All',
    nextPointer: null,
  },
  filterQuries: {
    model: {},
    folder: {},
    defect: {},
    usecase: {},
    groundTruth: {},
    gtModel: {},
    wafermap: {},
    aiOutput: {},
  },
  similarImages: {
    open: false,
    filters: {},
    dialogVariant: null,
    isLoading: false,
  },
};

export default initialState;
